var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 55,
    viewBox: "0 0 80 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C14.8992 0 0 27.2981 0 27.2981C0 27.2981 14.8992 54.5956 40 54.5956C65.1008 54.5956 80 27.2981 80 27.2981C80 27.2981 65.1008 0 40 0ZM39.9993 43.5852C31.0187 43.5852 23.7123 36.2787 23.7123 27.2981C23.7123 18.3175 31.0187 11.0111 39.9993 11.0111C48.9799 11.0111 56.2864 18.3175 56.2864 27.2981C56.2864 36.2787 48.9799 43.5852 39.9993 43.5852Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9996 37.3016C45.3096 37.3016 49.6141 32.997 49.6141 27.6871C49.6141 22.3771 45.3096 18.0726 39.9996 18.0726C34.6897 18.0726 30.3851 22.3771 30.3851 27.6871C30.3851 32.997 34.6897 37.3016 39.9996 37.3016Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f969da14.svg";
export { ForwardRef as ReactComponent };